export class AuthToken {
    public accessToken?: string;
    public refreshToken?: string;
    public expires?: number;
}